import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
// import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes'; // Asegúrate de exportar 'routes' desde tu AppRoutingModule

// Configuración de Idioma (Catalán)
import { registerLocaleData } from '@angular/common';
import localeCa from '@angular/common/locales/ca';
registerLocaleData(localeCa);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // provideAnimations(),
    { provide: LOCALE_ID, useValue: 'ca' },
    // importProvidersFrom permite usar módulos clásicos en la nueva configuración
    importProvidersFrom(
    )
  ]
};